// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"6d57bdc1","178":"0f854d4e","205":"edfe0db1","312":"06b37c31","551":"7be1c52c","675":"b898e9a9","800":"b86ba90f","828":"1197b251","873":"a40d6d4a"}[chunkId] + ".chunk.js";
};